$(document).ready(function () {

  function hasBuckleSelector(container = document) {
    return $(container).find(".buckle-options-main").length > 0;
  }

  function initQuickCartWatcher() {
    const observer = new MutationObserver(function () {

      const $drawer = $("quick-buy-drawer");
      if (!$drawer.length) return;
      const $btn = $drawer.find("form[action='/cart/add'] button[type='submit']");
      if ($btn.length) {
        console.log("binding buckle events");
        console.log("Quick cart detected → running toggleCartButtons");
        toggleCartButtons();
        syncBuckleVariants();
        autoSelectMatchingBuckle();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  initQuickCartWatcher();

  function getSelectedBuckleSize() {
    var variantId = $("form.shopify-product-form input[name='id']").val();
    console.log("variantIdvariantId: ",variantId);
    var variant = window.productVariants.find(v => v.id == variantId);
    if (!variant) return null;
    var sizeOptionIndex = -1;

    if (window.productData && window.productData.options) {
      sizeOptionIndex = window.productData.options.findIndex(
        option => option.toLowerCase() === "size"
      );
    }

    if (sizeOptionIndex === -1) return null;
    var sizeValue = variant["option" + (sizeOptionIndex + 1)];
    if (!sizeValue || sizeValue.indexOf("/") === -1) return null;
    return sizeValue.split("/")[1].trim();
  }

  function autoSelectMatchingBuckle() {
    var buckleSize = getSelectedBuckleSize();
    if (!buckleSize) return;
    console.log("Looking for buckle:", buckleSize);
    var $activeTab = $(".buckle-selector-tab-content-wrap.active");
    var $match = $activeTab.find('.buckle-option-variant[data-buckle-size="' + buckleSize + '"]').first();

    if (!$match.length) {
      console.warn("No buckle found for", buckleSize);
      return;
    }

    $activeTab.find(".buckle-option-variant").removeClass("active");
    $match.addClass("active");
    updatePrice();
    updateBuckleProperties();
    toggleCartButtons();
  }
  
  var bundleId,buckleId;
  let qty = 1;

  function findMatchingVariant(variants) {
    var buckleSize = getSelectedBuckleSize();
    if (!buckleSize) return null;
    return variants.find(function(v) {
      return (
        v.option1 === buckleSize ||
        v.option2 === buckleSize ||
        v.option3 === buckleSize
      );
    });
  }

  // "18mm" should match "18mm" as well as "18mm - Stainless Steel".
  function variantMatchesSize(v, size) {
    if (!size) return false;
    var wanted = String(size).trim().toLowerCase();
    return [v.option1, v.option2, v.option3].some(function (o) {
      if (typeof o !== "string") return false;
      var opt = o.trim().toLowerCase();
      return opt === wanted || new RegExp("^" + wanted.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") + "(?![0-9a-z])").test(opt);
    });
  }

  // Switch buckle tab; make sure the shown tab has a selection so the
  // "Selected Buckle" property always reflects what the customer sees.
  function activateBuckleTab(index) {
    $(".buckle-selector-tab").removeClass("active");
    $('.buckle-selector-tab[data-index="' + index + '"]').addClass("active");
    $(".buckle-selector-tab-content-wrap").removeClass("active").hide();
    var $wrap = $('.buckle-selector-tab-content-wrap[data-index="' + index + '"]').addClass("active").show();
    if (!$wrap.find(".buckle-option-variant.active:not([hidden])").length) {
      $wrap.find(".buckle-option-variant").removeClass("active");
      $wrap.find(".buckle-option-variant:not([hidden])").first().addClass("active");
    }
    updatePrice();
    updateBuckleProperties();
    toggleCartButtons();
  }

  function syncBuckleVariants() {
    var buckleSize = getSelectedBuckleSize();

    if (!buckleSize) {
      console.warn("No buckle size found");
      return;
    }

    console.log("Syncing buckle size:", buckleSize);

    $(".classic-buckle").each(function () {
      var $card = $(this);
      var productId = parseInt($card.attr("data-product-id"));
      var match = window.classicVariants.find(function (v) {
        return (
          v.productId === productId &&
          (
            v.option1 === buckleSize ||
            v.option2 === buckleSize ||
            v.option3 === buckleSize
          )
        );
      });

      if (!match) {
        console.warn("No classic variant found", productId, buckleSize);
        return;
      }

      $card.attr("data-id", match.id);
      $card.attr("data-variant-title", match.title);
      console.log("Classic updated:", productId, match.title, match.id);
    });

    /*
    * DEPLOYANT CLASPS (one card per configured clasp product)
    */
    var deployVariants = window.deploymentVariants || [];
    var $deployCards = $(".deployment-buckle");
    var visibleDeploy = 0;

    $deployCards.each(function () {
      var $card = $(this);
      var productId = parseInt($card.attr("data-product-id"));
      var candidates = deployVariants.filter(function (v) {
        // Legacy data (no productId) applies to every card.
        return (v.productId == null || v.productId === productId) && variantMatchesSize(v, buckleSize);
      });
      // Prefer the stainless steel finish when a clasp comes in several colours.
      var match = candidates.find(function (v) {
        return /stainless|steel|silver/i.test([v.option1, v.option2, v.option3, v.title].join(" "));
      }) || candidates[0];

      if (!match) {
        console.warn("No deployant clasp variant found", productId, buckleSize);
        $card.removeClass("active").attr("hidden", "hidden").removeAttr("data-id data-variant-title");
        return;
      }

      visibleDeploy++;
      $card.removeAttr("hidden");
      $card.attr("data-id", match.id);
      $card.attr("data-variant-title", match.title);
      $card.attr("data-buckle-price", match.price);
      console.log("Deployant updated:", productId, match.title, match.id);
    });

    // Hide the Deployant Clasp tab entirely when no clasp exists in this buckle width.
    var $deployTab = $('.buckle-selector-tab[data-index="2"]');
    if ($deployCards.length && visibleDeploy === 0) {
      $deployTab.attr("hidden", "hidden");
      if ($deployTab.hasClass("active")) {
        activateBuckleTab(1);
      }
    } else {
      $deployTab.removeAttr("hidden");
    }
    // Compact picker: with only one chip left there is nothing to choose, so hide the row.
    $(".buckle-selector-tab-container").each(function () {
      var visibleTabs = $(this).find(".buckle-selector-tab:not([hidden])").length;
      $(this).toggleClass("buckle-tabs-single", visibleTabs < 2);
    });
    updateBuckleSummary();

    /*
    * Update selected buckle title if active
    */
    var $active = $(".buckle-option-variant.active");
    if ($active.length) {
      var variantTitle = $active.attr("data-variant-title");
      if (variantTitle) {
        var productTitle = $active.find(".buckle-option-variant-title")
          .text().split(" - ")[0].trim();
        $active.attr("data-display-title",productTitle + " - " + variantTitle);
      }
    }
  }

  syncBuckleVariants();

  document.addEventListener("variant:change", function(event) {
    console.log("variant changed");
    var buckleSize = getSelectedBuckleSize();
    console.log("Selected buckle size:", buckleSize);
    syncBuckleVariants();
    var $active = $(".buckle-option-variant.active");
    if ($active.length) {
      updateBuckleProperties();
      updatePrice();
    }
    console.log("Active buckle after sync:",$active.attr("data-id"));
  });

  function toggleCartButtons() {
    if (!hasBuckleSelector()) return;
    var hasActive = $('.buckle-selector-tab-content-wrap.active .buckle-option-variant.active:not([hidden])').length > 0;
    // Size-not-chosen / missing add-on details lock wins over the buckle state (see applyCartLock).
    // While locked, applyCartLock owns the buttons (clickable, labelled with the reason; see 1.2.3 below).
    if (typeof window.cartLockEffective === 'function' && window.cartLockEffective()) return;
    if (typeof window.selectedVariantSoldOut === 'function' && window.selectedVariantSoldOut()) hasActive = false;
    var $addToCart = $('form[action="/cart/add"] button[type="submit"]');
    var $buyNow = $('.shopify-payment-button');

    // NEW selectors
    var $customBtn = $('button[is="custom-button"]');
    var $mobileBuyBtn = $('.mobile-only.mob-buy-btn .buy_strap_mob');
    if (hasActive) {
      // Enable Add to Cart
      $addToCart.prop('disabled', false).removeAttr('disabled').removeClass('disabled');
      // Enable Buy Now
      $buyNow.removeClass('disabled').removeAttr('disabled')
      .css({ 'pointer-events': 'auto', 'opacity': '1' });
      // Enable custom button
      $customBtn.prop('disabled', false).removeAttr('disabled').removeClass('disabled');

      // Enable mobile button
      $mobileBuyBtn.prop('disabled', false).removeAttr('disabled').removeClass('disabled')
      .css({ 'pointer-events': 'auto', 'opacity': '1' });

    } else {
      // Disable Add to Cart
      $addToCart.prop('disabled', true).attr('disabled', 'disabled').addClass('disabled');

      // Disable Buy Now
      $buyNow.addClass('disabled').attr('disabled', 'disabled')
      .css({ 'pointer-events': 'none', 'opacity': '0.5' });

      // Disable custom button
      $customBtn.prop('disabled', true).attr('disabled', 'disabled').addClass('disabled');

      // Disable mobile button
      $mobileBuyBtn.prop('disabled', true).attr('disabled', 'disabled').addClass('disabled')
      .css({ 'pointer-events': 'none', 'opacity': '0.5' });
    }
  }

  toggleCartButtons();

  buckleId = "buckle_" + Date.now();

  $(document).on("click", ".buckle-option-variant", function () {
    console.log("clciked");
    if (!hasBuckleSelector()) return;
    buckleId = "buckle_" + Date.now();
    var $parent = $(this).closest(".buckle-option-tab-content, .buckle-selector-tab-content-wrap");

    // Re-clicking the selected swatch keeps it selected (a buckle is always required).
    if ($(this).hasClass("active")) return;
    $parent.find(".buckle-option-variant").removeClass("active");
    $(this).addClass("active");

    updatePrice();
    updateBuckleProperties();
    toggleCartButtons();
  });

  function getVariantPriceFromForm(){
    var variantId = $("form.shopify-product-form input[name='id']").val();
    var variant = window.productVariants.find(v => v.id == variantId);
    console.log("variantform: ".variant);
    return variant ? variant.price : 0;
  }

  function updateQuantity(newQty) {
    qty = Math.max(1, parseInt(newQty) || 1);
    $(".quantity-selector__input").val(qty);
  }

  $(document).on('input', '.quantity-selector__input', function () {
    updateQuantity($(this).val());
  });

  $(document).on('click', '.quantity-selector__button', function () {
    var $input = $(".quantity-selector__input");
    var currentQty = parseInt($input.val()) || 1;

    if ($(this).attr('aria-label') === 'Increase quantity') {
      updateQuantity(currentQty);
    } else if ($(this).attr('aria-label') === 'Decrease quantity') {
      updateQuantity(currentQty - 1);
    }
  });

  function getCurrentQuantity() {
    return qty;
  }

  function formatMoney(cents, format = "") {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
    function defaultTo(value2, defaultValue) {
      return value2 == null || value2 !== value2 ? defaultValue : value2;
    }
    
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ",");
      decimal = defaultTo(decimal, ".");
      if (isNaN(number) || number == null) {
        return 0;
      }
      number = (number / 100).toFixed(precision);
      let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
      return dollarsAmount + centsAmount;
    }
    let value = "";
    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ");
        break;
      case "amount_no_decimals_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 0, "'");
        break;
    }
    if (formatString.indexOf("with_comma_separator") !== -1) {
      return formatString.replace(placeholderRegex, value);
    } else {
      return formatString.replace(placeholderRegex, value);
    }
  }

  var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;

  // Delegated so tabs inside the quick-buy drawer (rendered later) work too.
  $(document).on('click', '.buckle-selector-tab', function () {
    activateBuckleTab($(this).data('index'));
  });

  function updatePrice(){
    var variantPrice = 0;

    if(window.currentVariant){
      variantPrice = window.currentVariant.price;
    } else {
      variantPrice = getVariantPriceFromForm();
    }
    console.log("variantPrice:", variantPrice);

    var $activeBuckle = $(".buckle-selector-tab-content-wrap.active .buckle-option-variant.active");

    var bucklePrice = $activeBuckle.length ? parseInt($activeBuckle.attr("data-buckle-price")) : 0;
    console.log("bucklePrice:", bucklePrice);
    var finalPrice = variantPrice + bucklePrice;
    console.log("finalPrice:", finalPrice);

    var formattedPrice = formatMoney(finalPrice, currencyFormat);
    console.log("formattedPrice: ",formattedPrice);

    $("price-list sale-price").html(formattedPrice);
  }

  // Compact picker: "Buckle: Polished" + "Included" / "+ $30" in the header line.
  function updateBuckleSummary(){
    $(".buckle-compact").each(function () {
      var $box = $(this);
      var fmt = (typeof currencyFormat !== 'undefined' && currencyFormat) || "";
      var moneyOf = function (cents) {
        return formatMoney(cents, fmt).replace(/<[^>]*>/g, '').replace(/\.00(?=\D|$)/, '').trim();
      };
      // Clasp chip shows the price of the clasp that fits the current buckle width.
      var $clasp = $box.find(".deployment-buckle:not([hidden])").first();
      var claspPrice = parseInt($clasp.attr("data-buckle-price")) || 0;
      $box.find('.buckle-selector-tab[data-index="2"] .buckle-tab-sub').text(claspPrice > 0 ? "+ " + moneyOf(claspPrice) : "");
      var $active = $box.find(".buckle-selector-tab-content-wrap.active .buckle-option-variant.active:not([hidden])").first();
      var $name = $box.find(".buckle-selected-name");
      var $price = $box.find(".buckle-selected-price");
      if (!$active.length) { $name.text(""); $price.text(""); return; }
      var label = $.trim($active.find(".buckle-swatch-label").text()) || $.trim($active.attr("data-product-title") || "");
      if ($active.hasClass("deployment-buckle")) label += " clasp";
      var price = parseInt($active.attr("data-buckle-price")) || 0;
      $name.text(label);
      $price.text(price > 0 ? "+ " + moneyOf(price) : "Included");
    });
  }

  function updateBuckleProperties(){
    updateBuckleSummary();

    var $active = $(".buckle-selector-tab-content-wrap.active .buckle-option-variant.active");
    var $form = $("form.shopify-product-form");

    $form.find("input[name^='properties[Buckle']").remove();
    $form.find("input[name^='properties[Selected']").remove();
    $form.find("input[name='properties[_bundle]']").remove();

    if(!$active.length) return;

    var productTitle = $active.attr("data-product-title") || '';
    var variantTitle = $active.attr("data-variant-title") || '';
    var buckleTitle = productTitle;

    if (variantTitle) {
      buckleTitle += " - " + variantTitle;
    }

    var bucklePrice = parseInt($active.attr("data-buckle-price")) || 0;
    var formattedBucklePrice = formatMoney(bucklePrice, currencyFormat).replace(/<[^>]*>/g, '').trim();
    console.log("formattedBucklePrice: ",bucklePrice, formattedBucklePrice);
    console.log("Selected Buckletitle:", buckleTitle);

    $("<input>", {
      type: "hidden",
      name: "properties[Selected Buckle]",
      value: buckleTitle
    }).appendTo($form);

    if(bucklePrice > 0){
      $("<input>", {
        type: "hidden",
        name: "properties[Buckle Cost]",
        value: formattedBucklePrice
      }).appendTo($form);

      $("<input>", {
        type: "hidden",
        name: "properties[_bundle]",
        value: buckleId
      }).appendTo($form);
    }
  }

  function updateDrawer(cart){
    console.log("Updating cart drawer");
    document.dispatchEvent(
      new CustomEvent("cart:change", { detail: { cart: cart } })
    );
    document.dispatchEvent(new CustomEvent("cart:refresh"));
  }

  $(document).on("submit", "form.shopify-product-form", function () {

    var $form = $(this);
    var $active = $(".buckle-selector-tab-content-wrap.active .buckle-option-variant.active");
    if(!$active.length) return;

    var bucklePrice = parseInt($active.attr("data-buckle-price")) || 0;
    if(bucklePrice <= 0) return;

    // Get the current qty value
    var currentQty = getCurrentQuantity();

    // Example log, replace with your logic
    console.log('Current quantity is:', currentQty);
    console.log("Submitting buckle variant:", $active.attr("data-id"));
    var buckleVariantId = parseInt($active.attr("data-id"));

    // wait until theme confirms cart change (main product added)
    document.addEventListener("cart:change", function addBuckleOnce(){

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: buckleVariantId,
          quantity: currentQty,
          properties: {
            "_installed": "Yes",
            "Installed": "Yes",
            "_bundle": buckleId
          }
        })
      })
      .then(() => fetch('/cart.js')).then(res => res.json()).then(cart => {
        document.dispatchEvent(
          new CustomEvent("cart:change", { detail: { cart: cart } })
        );
        document.dispatchEvent(new CustomEvent("cart:refresh"));
      });

      // ensure it runs only once
      document.removeEventListener("cart:change", addBuckleOnce);

    });
  });

  $(document).on("click", ".remove_bundle", function(e){
    e.preventDefault();
    console.log("Bundle remove clicked");

    var $row = $(this).closest(".cart-item, line-item");
    var bundleId = $row.data("bundle");
    console.log("Bundle ID:", bundleId);

    if(!bundleId){
      console.log("No bundle id found");
      return;
    }

    console.log("Fetching cart");

    fetch("/cart.js")
      .then(res => res.json())
      .then(cart => {
        console.log("Cart loaded:", cart);
        var updates = {};
        cart.items.forEach(function(item){
          if(item.properties && item.properties._bundle === bundleId){
            console.log("Marking item for removal:", item.key);
            updates[item.key] = 0;
          }
        });

        console.log("Updates object:", updates);

        if(Object.keys(updates).length === 0){
          console.log("No bundle items found");
          return;
        }

        console.log("Sending batch removal");

        return fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            updates: updates
          })
        });

      })
      .then(res => res.json())
      .then(cart => {

        console.log("Final cart after bundle removal:", cart);
        if(window.location.pathname === "/cart"){
          console.log("Reloading cart page");
          location.reload();
      }else{
        console.log("Updating cart drawer");
        document.dispatchEvent(
          new CustomEvent("cart:change", { detail: { cart: cart } })
        );

        document.dispatchEvent(new CustomEvent("cart:refresh"));
        if(typeof updateDrawer === "function"){
          updateDrawer(cart);
        }
      }
    })
    .catch(err => {
      console.error("Bundle removal failed:", err);
    });

  });

  $(document).on('click', 'x-listbox button', function() {
    var inStock = $('sold-out-badge.badge--sold-out').is('[hidden]');
    var $badge = $('.availability_badge.mobile_avail_badge');
    if ($badge.data('in')) {
      // Stock promise (1.2.1): data-in / data-out hold the HTML for each state.
      $badge.find('p').html(inStock ? $badge.data('in') : $badge.data('out')).toggleClass('stock-promise--out', !inStock);
    } else {
      $badge.find('p').text(inStock ? 'Available' : 'Sold Out');
    }
  });

  // Slider arrow icons (shared by the gallery and the mobile multi-column sliders).
  var SLICK_NEXT_ARROW = '<div class="slide-arrow next-arr-slide"><svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.97415 5.75045L0.781874 10.6977C0.695239 10.7803 0.580137 10.8264 0.460443 10.8264C0.340749 10.8264 0.225648 10.7803 0.139013 10.6977L0.133422 10.6921C0.0912776 10.6521 0.0577183 10.6039 0.0347862 10.5505C0.0118542 10.497 2.81334e-05 10.4395 2.81334e-05 10.3814C2.81334e-05 10.3233 0.0118542 10.2657 0.0347862 10.2123C0.0577183 10.1589 0.0912776 10.1107 0.133422 10.0707L5.0229 5.41225L0.133422 0.755695C0.0912776 0.715658 0.0577183 0.667465 0.0347862 0.614049C0.0118542 0.560633 2.81334e-05 0.503109 2.81334e-05 0.444979C2.81334e-05 0.386848 0.0118542 0.329326 0.0347862 0.275909C0.0577183 0.222493 0.0912776 0.174299 0.133422 0.134262L0.139013 0.128672C0.225648 0.0460825 0.340749 1.04904e-05 0.460443 1.04904e-05C0.580137 1.04904e-05 0.695239 0.0460825 0.781874 0.128672L5.97415 5.07591C6.01981 5.11942 6.05617 5.17175 6.081 5.22972C6.10584 5.2877 6.11865 5.35011 6.11865 5.41318C6.11865 5.47625 6.10584 5.53867 6.081 5.59664C6.05617 5.65462 6.01981 5.70695 5.97415 5.75045Z" fill="black"/></svg></div>';
  var SLICK_PREV_ARROW = '<div class="slide-arrow prev-arr-slide"><svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.144504 5.75045L5.33678 10.6977C5.42341 10.7803 5.53852 10.8264 5.65821 10.8264C5.7779 10.8264 5.893 10.7803 5.97964 10.6977L5.98523 10.6921C6.02737 10.6521 6.06093 10.6039 6.08387 10.5505C6.1068 10.497 6.11862 10.4395 6.11862 10.3814C6.11862 10.3233 6.1068 10.2657 6.08387 10.2123C6.06093 10.1589 6.02737 10.1107 5.98523 10.0707L1.09575 5.41225L5.98523 0.755695C6.02737 0.715658 6.06093 0.667465 6.08387 0.614049C6.1068 0.560633 6.11862 0.50311 6.11862 0.444979C6.11862 0.386848 6.1068 0.329326 6.08387 0.275909C6.06093 0.222493 6.02737 0.1743 5.98523 0.134262L5.97964 0.128672C5.893 0.0460835 5.7779 1.04904e-05 5.65821 1.04904e-05C5.53852 1.04904e-05 5.42341 0.0460835 5.33678 0.128672L0.144504 5.07591C0.0988405 5.11942 0.062487 5.17175 0.0376476 5.22972C0.0128082 5.2877 0 5.35011 0 5.41318C0 5.47625 0.0128082 5.53867 0.0376476 5.59664C0.062487 5.65462 0.0988405 5.70695 0.144504 5.75045Z" fill="black"/></svg></div>';

  // Main slider
  $('.mobile-gallery-slick').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    fade: true,
    asNavFor: '.media-thumbs-list',
    nextArrow: SLICK_NEXT_ARROW,
    prevArrow: SLICK_PREV_ARROW
  });

  // Thumbnail navigation
  $('.media-thumbs-list').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.mobile-gallery-slick',
    focusOnSelect: true,
    arrows: false,
    dots:false,
    infinite: true
  });

  $('.multi-column.mob-mode').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    infinite: true,
    nextArrow: SLICK_NEXT_ARROW,
    prevArrow: SLICK_PREV_ARROW
  });

  var $btn = $('.buy_strap_mob');

  function getVariantFromUrl() {
    var params = new URLSearchParams(window.location.search);
    return params.get('variant');
  }

  function updateVariantId() {
    var currentVariant = getVariantFromUrl();
    if (currentVariant) {
      $btn.attr('var_id', currentVariant);
    }
  }

  updateVariantId();

  $(document).on('variant:change', function (evt) {
    if (evt.detail && evt.detail.variant) {
      $btn.attr('var_id', evt.detail.variant.id);
    } else {
      updateVariantId();
    }
  });

  let lastUrl = location.href;
  setInterval(function () {
    if (location.href !== lastUrl) {
      lastUrl = location.href;
      updateVariantId();
    }
  }, 500);

  $btn.on('click', function (e) {
    e.preventDefault();

    var variant_id = $(this).attr('var_id');
    if (!variant_id) {
      alert('Please select a product option first.');
      return;
    }
    var lockReason = (typeof window.cartLockReason === 'function') ? window.cartLockReason() : null;
    if (lockReason) {
      alert({ 'Select your lug width': 'Please select your lug width first.', 'Enter your custom size': 'Please enter your custom size first.', 'Notch is wider than the strap': 'The notch width can\'t be greater than the strap width.' }[lockReason] || 'Please fill in the add-on details first.');
      return;
    }

    // Capture custom options
    var stitchingOption = $('#stitching-hidden').val();
    var springOption = $('#spring-hidden').val();
    var customNotes = $('#custom-notes').val();

    var properties = {};
    if (stitchingOption) {
      properties['Stitching Colour'] = stitchingOption;
    }
    if (springOption) {
      properties['Spring Bar'] = springOption;
    }
    if (customNotes) {
      properties['Notes'] = customNotes;
    }
    var $customSize = $('.variant-picker__custom:not([hidden]) .variant-picker__custom-input');
    if ($customSize.length && $.trim($customSize.val())) {
      properties['Custom size'] = $.trim($customSize.val());
    }

    // Capture the selected buckle (ready-to-wear buckle selector), mirroring the
    // desktop flow in updateBuckleProperties() / the form submit handler.
    var $activeBuckle = $(".buckle-selector-tab-content-wrap.active .buckle-option-variant.active");

    // The buckle is required on RTW products, so block checkout if none is chosen.
    if (hasBuckleSelector() && !$activeBuckle.length) {
      alert('Please select a buckle option first.');
      return;
    }

    var buckleVariantId = 0;
    var bucklePrice = 0;
    var mobileBuckleId = null;

    if ($activeBuckle.length) {
      var buckleProductTitle = $activeBuckle.attr('data-product-title') || '';
      var buckleVariantTitle = $activeBuckle.attr('data-variant-title') || '';
      var buckleTitle = buckleProductTitle;
      if (buckleVariantTitle) {
        buckleTitle += ' - ' + buckleVariantTitle;
      }
      properties['Selected Buckle'] = buckleTitle;

      bucklePrice = parseInt($activeBuckle.attr('data-buckle-price')) || 0;
      buckleVariantId = parseInt($activeBuckle.attr('data-id')) || 0;

      // Paid buckles are added as a separate bundled line item.
      if (bucklePrice > 0 && buckleVariantId) {
        mobileBuckleId = 'buckle_' + Date.now();
        properties['_bundle'] = mobileBuckleId;
      }
    }

    // MTO bespoke add-ons: give the strap the same hidden bundle id as its add-ons.
    if (!properties['_bundle'] && typeof window.mtoAddonsSelected === 'function' && window.mtoAddonsSelected().length) {
      properties['_bundle'] = window.mtoBundleId;
      window.mtoAddonsSelected().forEach(function (x) { properties[x.key] = x.value; });
    }

    // Add the strap to cart with custom + buckle properties
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variant_id,
        quantity: 1,
        properties: properties
      },
      dataType: 'json',
      success: function() {
        var finishMobile = function() {
        // For paid buckles, add the buckle as its own bundled line item
        // before heading to checkout.
        if (bucklePrice > 0 && buckleVariantId && mobileBuckleId) {
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              id: buckleVariantId,
              quantity: 1,
              properties: {
                '_installed': 'Yes',
                'Installed': 'Yes',
                '_bundle': mobileBuckleId
              }
            },
            dataType: 'json',
            complete: function() {
              window.location.href = '/checkout';
            }
          });
        } else {
          window.location.href = '/checkout';
        }
        };
        // MTO bespoke add-ons ride along as their own lines before checkout.
        var addonsDone = (typeof window.addMtoAddons === 'function') ? window.addMtoAddons(1, properties['_bundle']) : null;
        Promise.resolve(addonsDone).then(finishMobile, finishMobile);
      },
      error: function (xhr) {
        console.error('Add to cart failed:', xhr);
      }
    });
  });


  /* ===== MTO bespoke add-ons (1.2.1) =====
     Inline picker rendered by snippets/mto-addons.liquid on made-to-order straps.
     Desktop: the theme adds the strap and fires cart:change; we then add each ticked
     add-on as its own line (one /cart/add.js call with items[]), tagged "For: <strap>"
     and sharing a hidden _bundle id with the strap. Mobile Buy Now: see finishMobile. */
  var $mtoAddons = $('#mto-addons');
  if ($mtoAddons.length) {
    window.mtoBundleId = 'mto_' + Date.now();
    var mtoMoney = function (cents) {
      try { return formatMoney(cents, (typeof currencyFormat !== 'undefined' && currencyFormat) || '').replace(/<[^>]*>/g, '').replace(/\.00(?=\D|$)/, '').trim(); } catch (e) { return '$' + Math.round(cents / 100); }
    };
    var mtoResolve = function ($addon) {
      var data = $addon.data('mtoVariants');
      if (data === undefined) {
        var raw = $addon.find('.mto-addon__variants').text();
        data = raw ? JSON.parse(raw) : null;
        $addon.data('mtoVariants', data);
      }
      var title = $addon.attr('data-title') || '';
      // Extra typed details (e.g. notch width/depth) become line-item properties and a label suffix.
      // Number fields ending in "(mm)" get the unit; plain text fields (keeper colour) are carried as typed.
      var props = {}, propBits = [], plainVals = [];
      $addon.find('.mto-addon__field').each(function () {
        var val = $.trim(this.value);
        if (!val) return;
        var key = $(this).attr('data-prop') || this.name || 'Detail';
        if (/\(mm\)$/.test(key)) {
          props[key] = val + 'mm';
          propBits.push(key.replace(/\s*\(mm\)$/, '').toLowerCase() + ' ' + val + 'mm');
        } else {
          props[key] = val;
          propBits.push(val);
          plainVals.push(val);
        }
      });
      var fieldSuffix = propBits.length ? ' (' + propBits.join(', ') + ')' : '';
      // Cart line property per add-on (user 2026-10-24: "separated clearly"): ends AND conversions share the one
      // "Strap ends" radio group -> "Strap ends: Curved Ends (...)" / "Strap ends: For Santos de Cartier (...)";
      // extras -> "<Add-on name>: <chosen option or Added>".
      var group = $addon.attr('data-group') || 'extra';
      var keyFor = function (detail) {
        if (group === 'ends') return { key: 'Strap ends', value: title + (detail ? ' (' + detail + ')' : '') + fieldSuffix };
        if (group === 'conv') return { key: 'Strap ends', value: title + (detail ? ' (' + detail + ')' : '') + fieldSuffix };
        // Extras: the chosen option, else the typed text ("Custom Keeper Colour: Racing Green"), else "Added".
        if (detail) return { key: title, value: detail + fieldSuffix };
        return { key: title, value: plainVals.length ? plainVals.join(', ') : 'Added' };
      };
      if (!data) {
        var kv0 = keyFor('');
        return { id: parseInt($addon.attr('data-variant')) || 0, price: parseInt($addon.find('.mto-addon__price').attr('data-base')) || 0, available: true, label: title + fieldSuffix, key: kv0.key, value: kv0.value, props: props };
      }
      var sel = $addon.find('.mto-addon__select').map(function () { return this.value; }).get();
      var v = data.find(function (x) { return sel.every(function (val, i) { return x.options[i] === val; }); });
      if (!v) return null;
      var detail = sel.map(function (x) {
        var s = x.replace(/^\d+\.\s*/, '').replace(/\s*-\s*Recommended!?/i, '');
        // "Curved Ends (with Curved Spring Bars)" -> "with Curved Spring Bars"
        if (title && s.toLowerCase().indexOf(title.toLowerCase()) === 0) {
          s = s.slice(title.length).replace(/^\s*[(\-:]?\s*/, '').replace(/\)\s*$/, '');
        }
        return s;
      }).join(' / ');
      var kv = keyFor(detail);
      return { id: v.id, price: v.price, available: v.available, label: title + (detail ? ' (' + detail + ')' : '') + fieldSuffix, key: kv.key, value: kv.value, props: props };
    };
    var mtoSelected = function () {
      var out = [];
      $mtoAddons.find('.mto-addon[data-addon]:not([data-addon="standard"])').each(function () {
        var $a = $(this);
        if (!$a.find('.mto-addon__check').prop('checked')) return;
        var r = mtoResolve($a);
        if (r && r.id && r.available !== false) out.push(r);
      });
      return out;
    };
    window.mtoAddonsSelected = mtoSelected;
    var mtoRefresh = function () {
      $mtoAddons.find('.mto-addon').each(function () {
        var $a = $(this), on = $a.find('.mto-addon__check').prop('checked');
        $a.toggleClass('is-on', on);
        $a.find('.mto-addon__options').prop('hidden', !on);
        if ($a.attr('data-addon') === 'standard') return;
        var r = mtoResolve($a);
        var $price = $a.find('.mto-addon__price');
        if (!r) $price.text('Unavailable');
        else if (r.available === false) $price.text('Sold out');
        else $price.text(r.price > 0 ? '+' + mtoMoney(r.price) : 'Included');
      });
      var sel = mtoSelected();
      var total = sel.reduce(function (sum, x) { return sum + x.price; }, 0);
      var names = sel.map(function (x) { return x.label; });
      var $chosen = $mtoAddons.find('.mto-addons__chosen');
      // One hidden properties[<key>] input per chosen add-on -> separate lines in the cart (user 2026-10-24).
      var $bundle = $('#mto-addons-bundle');
      $mtoAddons.find('input.mto-addon-prop').remove();
      sel.forEach(function (x) {
        $('<input>', { type: 'hidden', 'class': 'mto-addon-prop', name: 'properties[' + x.key + ']', value: x.value, form: $bundle.attr('form') }).insertBefore($bundle);
      });
      if (sel.length) {
        $chosen.text(names.join(', ') + (total > 0 ? ' · +' + mtoMoney(total) : '')).prop('hidden', false);
        $bundle.val(window.mtoBundleId).prop('disabled', false);
      } else {
        $chosen.text('').prop('hidden', true);
        $bundle.val('').prop('disabled', true);
      }
      $mtoAddons.toggleClass('has-selection', sel.length > 0);
    };
    $mtoAddons.on('change', '.mto-addon__check, .mto-addon__select', function () { mtoRefresh(); prefillStrapWidth(); if (typeof window.applyCartLock === 'function') window.applyCartLock(); });
    $mtoAddons.on('input change', '.mto-addon__field', function () { $(this).attr('data-touched', '1'); mtoRefresh(); if (typeof window.applyCartLock === 'function') window.applyCartLock(); });
    mtoRefresh();

    window.addMtoAddons = function (qty, bundleId) {
      var sel = mtoSelected();
      if (!sel.length) return Promise.resolve();
      var strapTitle = $mtoAddons.attr('data-product-title') || '';
      var items = sel.map(function (x) {
        var props = $.extend({ 'For': strapTitle, '_bundle': bundleId || window.mtoBundleId }, x.props || {});
        return { id: x.id, quantity: qty || 1, properties: props };
      });
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function () { return fetch('/cart.js'); })
        .then(function (res) { return res.json(); })
        .then(function (cart) { updateDrawer(cart); return cart; })
        .catch(function (err) { console.error('Add-on add failed:', err); });
    };

    $(document).on('submit', 'form.shopify-product-form', function () {
      if (!mtoSelected().length) return;
      var qty = getCurrentQuantity() || 1;
      var bundleId = window.mtoBundleId;
      document.addEventListener('cart:change', function addAddonsOnce() {
        document.removeEventListener('cart:change', addAddonsOnce);
        window.addMtoAddons(qty, bundleId);
        // Fresh id for the next add so a second strap gets its own bundle.
        window.mtoBundleId = 'mto_' + Date.now();
        mtoRefresh();
      });
    });
  }


  /* ===== Strap width prefill for notch fields (1.2.1) =====
     First number of the chosen Size ("24mm/20mm" -> 24) goes into any .mto-addon__field[data-prefill="lug"]
     the customer has not typed in. */
  function selectedSizeText() {
    var txt = '';
    $('.variant-picker__option').each(function () {
      if (/size/i.test($(this).find('legend').first().text())) { txt = $.trim($(this).find('variant-option-value').text()); return false; }
    });
    return txt;
  }
  function prefillStrapWidth() {
    var m = selectedSizeText().match(/(\d+(?:\.\d+)?)\s*mm/i);
    if (!m) return;
    $('.mto-addon__field[data-prefill="lug"]').each(function () {
      if (!$(this).attr('data-touched') || !$.trim(this.value)) { this.value = m[1]; }
    });
    if (typeof window.applyCartLock === 'function') window.applyCartLock();
  }
  window.prefillStrapWidth = prefillStrapWidth;

  /* ===== Cart lock: size must be chosen / add-on details required (1.2.1) ===== */
  window.cartLockReason = function () {
    if (document.querySelector('.variant-picker__option[data-needs-choice]')) return 'Select your lug width';
    var cs = document.querySelector('.variant-picker__custom:not([hidden]) .variant-picker__custom-input');
    if (cs && !$.trim(cs.value)) return 'Enter your custom size';
    var missing = false;
    $('#mto-addons .mto-addon.is-on .mto-addon__field[required]').each(function () { if (!$.trim(this.value)) missing = true; });
    // Notched ends: notch width must not be greater than the strap width (user 2026-10-25).
    var tooWide = false;
    $('#mto-addons .mto-addon').each(function () {
      var $a = $(this), $n = $a.find('.mto-addon__field[data-notch="width"]');
      if (!$n.length) return;
      var strap = parseFloat($a.find('.mto-addon__field[data-prefill="lug"]').val()), notch = parseFloat($n.val());
      var bad = $a.hasClass('is-on') && !isNaN(strap) && !isNaN(notch) && notch > strap;
      $n.attr('aria-invalid', bad ? 'true' : 'false');
      $a.find('.mto-addon__error').prop('hidden', !bad);
      if (bad) tooWide = true;
    });
    if (tooWide) return 'Notch is wider than the strap';
    if (missing) return 'Fill in the add-on details';
    return null;
  };
  // True when the chosen variant cannot be bought (the theme labels the button "Sold out"); the buckle
  // code and the lock release must not re-enable it.
  function selectedVariantSoldOut() {
    var vp = document.querySelector('variant-picker');
    try { var v = vp && vp.selectedVariant; if (v) return v.available === false; } catch (e) {}
    var vid = $('form.shopify-product-form input[name="id"]').val();
    var v2 = (window.productVariants || []).find(function (x) { return String(x.id) === String(vid); });
    return !!(v2 && v2.available === false);
  }
  window.selectedVariantSoldOut = selectedVariantSoldOut;
  /* Clear locked button (1.2.3, user 2026-10-25): the locked Add to Cart stays full colour and CLICKABLE with the
     reason as its label; a capture-phase guard stops the add, scrolls to the missing field and, after that first
     tap, shows a red message under the button plus red outlines on what still needs filling in. */
  var LOCK_MSG = {
    'Select your lug width': 'Please select your lug width (Size) first.',
    'Enter your custom size': 'Please type your custom size in the box under Size.',
    'Notch is wider than the strap': 'The notch width can\'t be greater than the strap width.',
    'Fill in the add-on details': 'Please fill in the highlighted details for the add-on you chose under Further Customisation.'
  };
  function lockLabelEl(btn) { return (btn.getAttribute('is') === 'custom-button' && btn.firstElementChild) ? btn.firstElementChild : btn; }
  function effectiveLockReason() {
    var reason = window.cartLockReason();
    // A sold-out variant stays "Sold out" unless the size still has to be picked (another size may be available).
    if (reason && reason !== 'Select your lug width' && selectedVariantSoldOut()) return null;
    return reason;
  }
  window.cartLockEffective = effectiveLockReason;
  function setFieldMsg(host, text) {
    var $h = $(host), $m = $h.children('.lock-field-msg');
    if (!text) { $m.remove(); return; }
    if (!$m.length) $m = $('<p class="lock-field-msg" role="alert"></p>').appendTo($h);
    $m.text(text);
  }
  function lockMsgEl() {
    var $m = $('#cart-lock-msg');
    if ($m.length) return $m;
    $m = $('<p id="cart-lock-msg" class="cart-lock-msg" role="alert" hidden></p>');
    var $bb = $('form.shopify-product-form buy-buttons').not('.quick-buy-drawer *, quick-buy-drawer *').first();
    if ($bb.length) { $m.insertAfter($bb); } else { var $mb = $('.buy_strap_mob').first(); if ($mb.length) $m.insertAfter($mb); }
    return $m;
  }
  function renderLockErrors(reason) {
    if (!reason) document.body.classList.remove('cart-lock-tried');
    var show = !!reason && document.body.classList.contains('cart-lock-tried');
    $('.variant-picker__option').each(function () {
      var bad = show && this.hasAttribute('data-needs-choice');
      $(this).toggleClass('is-error', bad);
      if (!$(this).find('.variant-picker__hint').length) setFieldMsg(this, bad ? 'Please select your lug width.' : null);
    });
    $('.variant-picker__custom').each(function () {
      var inp = $(this).find('.variant-picker__custom-input')[0];
      var bad = show && !this.hidden && !!inp && !$.trim(inp.value);
      $(this).toggleClass('is-error', bad);
      setFieldMsg(this, bad ? 'Please enter your custom size.' : null);
    });
    $('#mto-addons .mto-addon').each(function () {
      var on = $(this).hasClass('is-on'), any = false;
      $(this).find('.mto-addon__field[required]').each(function () {
        var miss = show && on && !$.trim(this.value);
        $(this).toggleClass('is-missing', miss);
        if (miss) any = true;
      });
      var box = $(this).find('.mto-addon__fields')[0];
      if (box) setFieldMsg(box, any ? 'Please fill in the highlighted details.' : null);
    });
    var $m = lockMsgEl();
    if (show) { $m.text(LOCK_MSG[reason] || 'Please complete the highlighted options.').prop('hidden', false); }
    else { $m.prop('hidden', true).text(''); }
  }
  function applyCartLock() {
    var reason = effectiveLockReason();
    var soldOut = selectedVariantSoldOut();
    var $btns = $('form.shopify-product-form button[type="submit"]').not('.quick-buy-drawer *, quick-buy-drawer *');
    var $mob = $('.buy_strap_mob');
    var $sticky = $('.sticky-atc__btn');
    if (reason) {
      $btns.each(function () {
        $(this).prop('disabled', false).removeAttr('disabled').removeClass('disabled').addClass('is-locked')
          .attr({ 'aria-disabled': 'true', 'aria-describedby': 'cart-lock-msg' });
        lockLabelEl(this).textContent = reason;
      });
      $mob.prop('disabled', false).removeAttr('disabled').removeClass('disabled').addClass('is-locked')
        .attr('aria-disabled', 'true').css({ 'pointer-events': 'auto', 'opacity': '1' });
      $sticky.addClass('is-locked').prop('disabled', false).text(reason);
    } else {
      var s = (window.themeVariables && window.themeVariables.strings) || {};
      $btns.filter('.is-locked').each(function () {
        $(this).removeClass('is-locked').removeAttr('aria-disabled aria-describedby');
        lockLabelEl(this).textContent = soldOut ? (s.soldOutButton || 'Sold out') : (s.addToCartButton || 'Add to Cart');
      });
      $mob.removeClass('is-locked').removeAttr('aria-disabled');
      $sticky.removeClass('is-locked').text(soldOut ? 'Sold out' : 'Add to Cart').prop('disabled', soldOut);
      if (hasBuckleSelector()) { toggleCartButtons(); } else { $btns.prop('disabled', soldOut); $mob.prop('disabled', soldOut); }
    }
    renderLockErrors(reason);
  }
  // Scroll to (and open / focus) the first thing that still needs doing, and switch the red messages on.
  function cartLockGoTo(reason) {
    document.body.classList.add('cart-lock-tried');
    applyCartLock();
    var target = null;
    if (reason === 'Select your lug width') {
      target = document.querySelector('.variant-picker__option[data-needs-choice] .select');
    } else if (reason === 'Enter your custom size') {
      target = document.querySelector('.variant-picker__custom:not([hidden]) .variant-picker__custom-input');
    } else {
      var d = document.getElementById('mto-addons');
      if (d && !d.open) d.open = true;
      target = (reason === 'Notch is wider than the strap')
        ? document.querySelector('#mto-addons .mto-addon.is-on .mto-addon__field[aria-invalid="true"]')
        : document.querySelector('#mto-addons .mto-addon.is-on .mto-addon__field.is-missing');
    }
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(function () {
      if (target.tagName === 'INPUT') { try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); } }
      else { target.click(); }
    }, 450);
  }
  window.cartLockGoTo = cartLockGoTo;
  function mainProductFormId() {
    var bb = document.querySelector('form.shopify-product-form buy-buttons[form]');
    return bb ? bb.getAttribute('form') : null;
  }
  function isMainCartControl(el) {
    if (!el || !el.closest || el.closest('.quick-buy-drawer, quick-buy-drawer')) return null;
    var b = el.closest('button[type="submit"], .buy_strap_mob');
    if (!b) return null;
    if (b.classList.contains('buy_strap_mob')) return b;
    var f = b.form, id = mainProductFormId();
    // form.id is clobbered by the form's <input name="id"> (the variant), so read the attribute.
    return (f && f.getAttribute('is') === 'product-form' && (!id || f.getAttribute('id') === id)) ? b : null;
  }
  // Capture phase: runs before the theme's product-form, the mobile Buy Now handler and the add-ons listener.
  document.addEventListener('click', function (e) {
    if (!isMainCartControl(e.target)) return;
    var reason = effectiveLockReason();
    if (!reason) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    cartLockGoTo(reason);
  }, true);
  // Enter in a field linked to the form (e.g. the custom size box) submits it without a click.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || f.getAttribute('is') !== 'product-form') return;
    if (f.closest && f.closest('.quick-buy-drawer, quick-buy-drawer')) return;
    var id = mainProductFormId();
    if (id && f.getAttribute('id') !== id) return;
    var reason = effectiveLockReason();
    if (!reason) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    cartLockGoTo(reason);
  }, true);
  window.applyCartLock = applyCartLock;
  // First pick on the size listbox (1.2.1). The theme's x-listbox only reacts to a click once
  // aria-activedescendant has been set before (its attributeChangedCallback ignores oldValue === null),
  // and nothing sets it while no option carries aria-selected (the "Select your lug width" state).
  // So prime it with ANOTHER option's id in the capture phase; the theme's own click handler then sees a
  // real change and updates the hidden option input -> variant. Document-level capture also survives the
  // popover being moved to <body> on screens <= 999px (x-popover.shouldAppendToBody).
  document.addEventListener('click', function (e) {
    var opt = e.target && e.target.closest ? e.target.closest('x-listbox[data-needs-choice] .popover-listbox__option') : null;
    if (!opt) return;
    var lb = opt.closest('x-listbox');
    if (!lb.getAttribute('aria-activedescendant')) {
      var other = Array.prototype.find.call(lb.querySelectorAll('.popover-listbox__option'), function (o) { return o !== opt; });
      if (other && other.id) lb.setAttribute('aria-activedescendant', other.id);
    }
    lb.removeAttribute('data-needs-choice');
    var pop = lb.closest('x-popover');
    var ctrl = pop && pop.id ? document.querySelector('.select[aria-controls="' + pop.id + '"]') : null;
    var $f = ctrl ? $(ctrl).closest('.variant-picker__option') : $('.variant-picker__option[data-needs-choice]').first();
    var v = opt.getAttribute('value');
    $f.removeAttr('data-needs-choice').removeClass('needs-choice');
    $f.find('.select > span').first().removeClass('variant-picker__placeholder').text(v);
    $f.find('variant-option-value').text(v);
    $f.find('.variant-picker__hint').remove();
    setTimeout(function () { applyCartLock(); prefillStrapWidth(); }, 50);
  }, true);
  document.addEventListener('variant:change', function () {
    setTimeout(function () {
      // Changing the length before the size would otherwise print the default size in the legend.
      $('.variant-picker__option[data-needs-choice] variant-option-value').html('<span class="variant-picker__placeholder">Select your lug width</span>');
      prefillStrapWidth();
    }, 0);
  });
  /* ===== Custom size box on made-to-order pages (2026-10-25) =====
     snippets/variant-picker-mto-base.liquid renders .variant-picker__custom under the Size dropdown.
     Shown (input enabled + counted by cartLockReason) only while the chosen Size value is "Custom". */
  function syncCustomSize(variant) {
    $('.variant-picker__custom').each(function () {
      var $box = $(this), optName = $box.attr('data-custom-option');
      var idx = parseInt(String(optName).replace('option', ''), 10) - 1;
      var val = '';
      if (variant && variant.options) {
        val = variant.options[idx] || '';
      } else {
        var hid = document.querySelector('input[type="hidden"][name="' + optName + '"]');
        val = hid ? hid.value : '';
      }
      var on = String(val).trim().toLowerCase() === 'custom' && !$box.closest('.variant-picker__option').is('[data-needs-choice]');
      $box.prop('hidden', !on);
      $box.find('.variant-picker__custom-input').prop('disabled', !on);
    });
  }
  document.addEventListener('variant:change', function (evt) {
    syncCustomSize(evt.detail && evt.detail.variant);
    applyCartLock();
  });
  $(document).on('input change', '.variant-picker__custom-input', function () { applyCartLock(); });
  syncCustomSize(null);
  applyCartLock();
  prefillStrapWidth();

  /* ===== Sticky Add to Cart bar on phones (1.2.1) ===== */
  var stickyBar = document.getElementById('sticky-atc');
  if (stickyBar) {
    var mainAtc = document.querySelector('.product-info__buy-buttons button[type="submit"]') || document.querySelector('form.shopify-product-form button[type="submit"]');
    var mq = window.matchMedia('(max-width: 767px)');
    var atcVisible = false;
    var updateSticky = function () {
      var show = mq.matches && !atcVisible;
      stickyBar.hidden = !show;
      document.body.classList.toggle('sticky-atc-visible', show);
    };
    if (mainAtc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { atcVisible = entries[0].isIntersecting; updateSticky(); }, { threshold: 0.25 }).observe(mainAtc);
    }
    if (mq.addEventListener) { mq.addEventListener('change', updateSticky); } else if (mq.addListener) { mq.addListener(updateSticky); }
    updateSticky();
    $(stickyBar).on('click', '.sticky-atc__btn', function () {
      var reason = effectiveLockReason();
      if (reason) { cartLockGoTo(reason); return; }
      // Click the real Add to Cart button: the page carries two cart/add forms and only the one behind
      // this button is the theme's ajax <form is="product-form">; submitting the other one navigates to /cart.
      var btn = mainAtc || document.querySelector('form.shopify-product-form button[type="submit"]');
      if (btn) btn.click();
    });
    document.addEventListener('variant:change', function (evt) {
      if (evt.detail && evt.detail.variant) {
        try { $('.sticky-atc__price').text(formatMoney(evt.detail.variant.price, currencyFormat).replace(/<[^>]*>/g, '').trim()); } catch (e) {}
      }
    });
  }

});